import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  SharedFacade,
  customDecode,
  customEncode,
  decrypt,
  delayedFunctionCall,
  encrypt,
  isFeatureEnabled,
} from '@piqet-angular/data';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from 'libs/features/src/lib/menu/menu.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Subscription, lastValueFrom, skip, take } from 'rxjs';
import { menu } from 'libs/features/src/lib/menu/menu';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import {
  FeatureCodes,
  GuideTourEnum,
  LicenseType,
  adminRoleStr,
  advancedTourSteps,
  guideTourStep11Str,
  guideTourStep12Str,
  guideTourStep13Str,
  guideTourStep14Str,
  guideTourStep26Str,
  guideTourStep30Str,
  guideTourStep5Str,
  guideTourStep6Str,
} from '@piqet-angular/shared';
import { JoyrideService } from 'ngx-joyride';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-project-details-sidebar',
  templateUrl: './project-details-sidebar.component.html',
  styleUrls: ['./project-details-sidebar.component.scss'],
})
export class ProjectDetailsSidebarComponent implements OnInit, OnDestroy, AfterViewInit {
  settingIcon: any;
  scenarioIcon: any;
  FeatureCodes = FeatureCodes;
  reportIcon: any;
  menuItems: any;
  subMenu: any = [];
  menuDataForRoute: any = [];
  iconList: any;
  advancedTourSteps = advancedTourSteps;
  activatedRoute: any;
  @ViewChildren('accord') parents!: QueryList<NgbAccordion>;
  @ViewChildren('childaccord') children!: QueryList<NgbAccordion>;
  @ViewChild('accordion') accordion!: NgbAccordion;
  @Output() projectNameEvent = new EventEmitter<any>();
  @Input() sidebarTour: any;
  activatedRouteProjectId: any;
  sideBarCall!: Subscription;
  flagName: any;
  activeIdsMain: string[] = [];
  activeIdsSub: string[] = [];
  closeOthers = true;
  scenarioId: any;
  packageScenarioId: any;
  eId: any;
  mTr: any;
  currentRoute: any;
  guideTourStep5Str = guideTourStep5Str;
  guideTourStep6Str = guideTourStep6Str;
  guideTourStep11Str = guideTourStep11Str;
  guideTourStep12Str = guideTourStep12Str;
  guideTourStep13Str = guideTourStep13Str;
  guideTourStep14Str = guideTourStep14Str;
  guideTourStep26Str = guideTourStep26Str;
  guideTourStep30Str = guideTourStep30Str;
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @ViewChild('contentDiv') contentDiv!: ElementRef;
  @ViewChild('scrollableDiv') scrollableDiv!: ElementRef;
  isGuidedTour: boolean = false;
  iSTourOn: boolean = false;
  guidedTourData!: Subscription;
  stepNum: any;
  hasInterpretationAccess: boolean = false;

  /**
   * `chart-at-glance-v2` is the same screen on the GenerateChartReport
   * endpoint, opened in its own tab from the chart at a glance header while the
   * migration is verified. It has no sidebar entry of its own but still needs
   * the Report section active and expanded. Drop this together with the route.
   */
  private isChartGlanceRoute(route: any): boolean {
    return route == 'chart-at-glance' || route == 'chart-at-glance-v2';
  }

  private isReportGenerationRoute(route: any): boolean {
    return route == 'report-generation' || route == 'report-generation-v2';
  }

  // A menu item's link is the v1 route, so a v2 route has to match its v1
  // sibling for the item to highlight.
  private isSameRoute(link: any, route: any): boolean {
    return (
      link == route ||
      (this.isChartGlanceRoute(link) && this.isChartGlanceRoute(route)) ||
      (this.isReportGenerationRoute(link) && this.isReportGenerationRoute(route))
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    // When the window is resized, update the height
    if (!this.iSTourOn) this.updateHeight();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    this.setDynamicMenu();
  }

  constructor(
    public sharedFacade: SharedFacade,
    public sharedService: SharedService,
    public menuService: MenuService,
    public route: ActivatedRoute,
    public router: Router,
    private projectsService: ProjectsService,
    private elementRef: ElementRef,
    private swalService: SwalService,
    public joyrideService: JoyrideService,
    public reportService: ReportsService,
    private cookieService: CookieService
  ) {
    const url = location.href.split('/');
    this.currentRoute = url[url.length - 1].split('?')[0];
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.route.queryParams.subscribe((values: any) => {
      this.currentRoute = this.currentRoute
        ? location.href.split('/')[location.href.split('/').length - 1].split('?')[0]
        : '';
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['eId'] || value['id'];
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'];
      this.mTr = value['mTr'];
      if (values?.isTour) this.startTour();
      if (
        this.isChartGlanceRoute(this.currentRoute) ||
        this.isReportGenerationRoute(this.currentRoute) ||
        this.currentRoute == 'setting' ||
        this.currentRoute == 'interpretation'
      )
        this.activeIdsSub = [];
      if (this.currentRoute == 'scenario-list' && this.menuItems?.length)
        return (this.activeIdsSub = []);
      if (
        (value ||
          this.isChartGlanceRoute(this.currentRoute) ||
          this.currentRoute == 'interpretation' ||
          this.isReportGenerationRoute(this.currentRoute)) &&
        !values?.aTr
      ) {
        this.changeCurrentRoute();
      }
    });
    this.router.events.pipe(take(1)).subscribe((x: any) => {
      this.menuItems = [...menu];
      this.menuItems = this.menuItems.find((x: any) => x.text.toLowerCase() == 'projects')?.submenu;
      this.menuItems.forEach((item: any, i: any) => {
        if (x?.routerEvent?.urlAfterRedirects?.includes(`?param=`)) {
          return (this.menuItems[1].isActive = true);
        } else if (
          x?.routerEvent?.urlAfterRedirects?.includes(`report-generation`) ||
          x?.routerEvent?.urlAfterRedirects?.includes(`chart-at-glance`) ||
          x?.routerEvent?.urlAfterRedirects?.includes(`interpretation`)
        ) {
          return (this.menuItems[2].isActive = true);
        } else {
          return (item.isActive = this.checkActiveLink(x, item, i));
        }
      });
    });
    this.changeCurrentRoute();
    this.setDynamicMenu();
    this.checkInterpretationAccess();
  }

  changeCurrentRoute() {
    this.currentRoute = this.currentRoute
      ? location.href.split('/')[location.href.split('/').length - 1].split('?')[0]
      : '';
    if ((this.scenarioId || this.currentRoute == 'scenario-list') && this.menuItems?.length)
      this.openScenario(this.menuItems[1]?.submenu);
    if (
      this.isChartGlanceRoute(this.currentRoute) ||
      this.currentRoute == 'interpretation' ||
      this.isReportGenerationRoute(this.currentRoute)
    ) {
      this.navigate(
        this.menuItems?.find(
          (x: any) =>
            x.text.toLowerCase() ==
            (this.isReportGenerationRoute(this.currentRoute) ||
            this.isChartGlanceRoute(this.currentRoute) ||
            this.currentRoute == 'interpretation'
              ? 'report'
              : 'scenarios')
        )
      );
    }
  }

  checkActiveLink(data: any, item: any, i: any) {
    if (data.snapshot && i == 0) {
      let route = this.route.snapshot.routeConfig?.path;
      return route?.includes('setting');
    }
    if (data) {
      return (
        data?.routerEvent?.urlAfterRedirects?.includes('/' + item.link) ||
        data?.urlAfterRedirects?.includes('/' + item.link)
      );
    } else {
      return true;
    }
  }

  async navigate(children: any, ele?: any, link?: any, type?: string) {
    if (link === 'interpretation' && !this.hasInterpretationAccess) {
      return;
    }
    if (
      this.isChartGlanceRoute(children?.link) ||
      this.isReportGenerationRoute(link) ||
      this.isChartGlanceRoute(link) ||
      link == 'interpretation'
    ) {
      const res = await this.sharedService.checkValidationForProductSector(
        this.activatedRouteProjectId
      );
      if (res.data.msg != '' && res.data.hasOwnProperty('msg')) {
        this.swalService
          .confirm('Report validation', res.data.msg, '', undefined, true)
          .then(confirmed => {
            if (confirmed) {
            }
          });
      } else {
        if (ele?.length && res.data.msg != '' && res.data.hasOwnProperty('msg')) {
          return;
        }
        this.currentRoute = link ? link : this.currentRoute;
        if (link && ele) {
          const id =
            link === 'fill-data-list' ||
            link === 'wholesale-data-list' ||
            link === 'retail-list' ||
            link === 'consumer-list'
              ? ele.packageScenarioId
              : ele.scenarioId;
          const valueToEncrypt = `{ "id": ${id}, "packageScenarioId": ${ele.packageScenarioId}, "eId": ${ele.scenarioId}}`;
          const encryptedValue = encrypt(valueToEncrypt);
          const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
          this.router.navigate(
            [`projects/projects-setting/${customEncode(btoa(encodedValue))}/${link}`],
            { queryParams: { param: encryptedValue } }
          );
        }

        if (this.currentRoute.toLowerCase() != 'setting') {
          if (typeof children != 'string' || Object.keys(children) || children.length) {
            this.menuItems?.forEach((data: any) => {
              data.isActive = false;
              data?.submenu?.forEach((x: any) => {
                if (
                  this.isReportGenerationRoute(x?.link) ||
                  this.isChartGlanceRoute(x?.link) ||
                  x?.link == 'interpretation'
                ) {
                  x.isActive = false;
                  if (this.isSameRoute(x?.link, this.currentRoute)) {
                    x.isActive = true;
                  }
                }
              });

              if (children == 'isScenario') {
                this.accordion.collapseAll();
              } else if (data?.link == children.link) {
                data.isActive = true;
              }
            });

            if (children.text != 'Report') {
              this.menuItems[1].submenu.forEach((y: any) => {
                y['activeScenario'] = false;
              });
              children?.submenu?.forEach((x: any) => {
                x['activeScenario'] = false;
                if (x?.scenarioId == (ele?.scenarioId || this.scenarioId)) {
                  x['activeScenario'] = true;
                  children.isActive = true;
                }
              });
            }
            if (
              this.isChartGlanceRoute(this.currentRoute) ||
              this.currentRoute == 'interpretation' ||
              this.isReportGenerationRoute(this.currentRoute)
            ) {
              this.activeIdsMain = [];
              this.activeIdsSub = [];
              this.activeIdsMain.push(`panel-main-2`);
            }
            this.sharedService.scenarioNameFunc(ele?.text);
          }
        } else {
          this.menuItems?.forEach((data: any) => {
            if (data.link == 'setting') {
              data.isActive = true;
              this.accordion.collapseAll();
            } else {
              data.isActive = false;
            }
            data?.submenu?.forEach((x: any) => {
              x.isActive = false;
            });
          });
        }
      }
    } else {
      this.currentRoute = link ? link : this.currentRoute;
      if (link && ele) {
        const id =
          link === 'fill-data-list' ||
          link === 'wholesale-data-list' ||
          link === 'retail-list' ||
          link === 'consumer-list'
            ? ele.packageScenarioId
            : ele.scenarioId;
        const valueToEncrypt = `{ "id": ${id}, "packageScenarioId": ${ele.packageScenarioId}, "eId": ${ele.scenarioId}}`;
        const encryptedValue = encrypt(valueToEncrypt);
        const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
        this.router.navigate(
          [`projects/projects-setting/${customEncode(btoa(encodedValue))}/${link}`],
          { queryParams: { param: encryptedValue } }
        );
      }

      if (this.currentRoute.toLowerCase() != 'setting') {
        if (typeof children != 'string' || Object.keys(children) || children.length) {
          this.menuItems?.forEach((data: any) => {
            data.isActive = false;
            data?.submenu?.forEach((x: any) => {
              if (
                this.isReportGenerationRoute(x?.link) ||
                this.isChartGlanceRoute(x?.link) ||
                x?.link == 'interpretation'
              ) {
                x.isActive = false;
                if (this.isSameRoute(x?.link, this.currentRoute)) {
                  x.isActive = true;
                }
              }
            });

            if (children == 'isScenario') {
              this.accordion.collapseAll();
            } else if (data?.link == children.link) {
              data.isActive = true;
            }
          });

          if (children?.text != 'Report') {
            this.menuItems[1].submenu.forEach((y: any) => {
              y['activeScenario'] = false;
            });
            children?.submenu?.forEach((x: any) => {
              x['activeScenario'] = false;
              if (x?.scenarioId == (ele?.scenarioId || this.scenarioId)) {
                x['activeScenario'] = true;
                children.isActive = true;
              }
            });
          }
          if (
            (this.isChartGlanceRoute(this.currentRoute) && history.state.isFromNext) ||
            this.currentRoute == 'interpretation' ||
            this.isReportGenerationRoute(this.currentRoute)
          ) {
            this.activeIdsMain = [];
            this.activeIdsSub = [];
            this.activeIdsMain.push(`panel-main-2`);
          }
          this.sharedService.scenarioNameFunc(ele?.text);
        }
      } else {
        this.menuItems?.forEach((data: any) => {
          if (data.link == 'setting' && !this.isGuidedTour) {
            data.isActive = true;
            this.accordion.collapseAll();
          } else if (data.link == 'setting' && this.isGuidedTour) {
            data.isActive = true;
          } else {
            data.isActive = false;
          }
          data?.submenu?.forEach((x: any) => {
            x.isActive = false;
          });
        });
      }
    }
  }

  collapsePanel(children: any, link: any) {
    this.accordion.collapseAll();
    const element = this.elementRef.nativeElement.querySelector('.menutext');
    const elementClasses = element.classList;
    if (elementClasses) {
      elementClasses.add('active');
    }

    this.navigate(children, null, link);
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    this.router.navigate([`projects/projects-setting/${customEncode(btoa(encodedValue))}/setting`]);
  }

  setDynamicMenu() {
    const projectId = this.activatedRouteProjectId;
    this.projectsService.getProjectDetailSideMenu(projectId).subscribe((response: any) => {
      let submenu: any = [{ text: 'Configuration', link: 'scenario-configuration' }];
      if (response) {
        this.subMenu = [];
        response.data?.scenarios.forEach((element: any) => {
          const record = this.createSubmenuArray(element);
          const isDuplicate = this.subMenu.some((data: any) => {
            return data.scenarioId === record.scenarioId;
          });
          if (!isDuplicate) {
            this.subMenu.push(record);
          }
        });
        response.data?.projectScopes.forEach((el: any) => {
          const record = this.createSubmenuArray(el);
          submenu.push(record);
        });
        this.setSubmenu(submenu);
        if ((this.scenarioId || this.currentRoute == 'scenario-list') && this.menuItems?.length)
          this.openScenario(this.menuItems[1]?.submenu);
        if (this.menuItems[1]?.submenu[0]?.scenarioId)
          localStorage.setItem('sId', this.menuItems[1].submenu[0]?.scenarioId);
        this.sharedService.accessSideMenuArray(submenu);
      }
      this.projectNameEvent.emit(response?.data?.projectName);
    });
  }

  openScenario(subMenu: any) {
    if (this.currentRoute == 'scenario-list') {
      this.openScenarioDropdown();
    } else {
      const scenarioIndx = subMenu.findIndex((x: any) => x.scenarioId == this.scenarioId);
      this.openScenarioDropdown(1, scenarioIndx);
    }
  }

  openScenarioDropdown(indx?: any, scenarioIndx?: any) {
    this.activeIdsMain = [];
    this.activeIdsSub = [];
    if (!indx && this.currentRoute == 'scenario-list') {
      this.activeIdsMain.push(`panel-main-1`);
    } else if (indx) {
      this.activeIdsMain.push(`panel-main-${indx}`);
      this.activeIdsSub.push(`panel-sub-${scenarioIndx}`);
    }
  }

  setSubmenu(submenu: any) {
    this.subMenu = this.subMenu.map((x: any) => ({
      ...x,
      submenu: submenu,
    }));

    this.menuItems.forEach((el: any) => {
      if (el.text.toLowerCase() == 'scenarios') {
        return (el.submenu = this.subMenu);
      }
    });
    this.navigate(
      this.menuItems.find(
        (x: any) =>
          x.text.toLowerCase() ==
          (this.isReportGenerationRoute(this.currentRoute) ||
          this.isChartGlanceRoute(this.currentRoute) ||
          this.currentRoute == 'interpretation'
            ? 'report'
            : 'scenarios')
      )
    );
  }

  createSubmenuArray(element: any) {
    const link = element.hasOwnProperty('description') ? element.description : '#';
    return {
      text: element.name,
      shortName: element.shortName,
      link: link,
      scenarioId: element.scenarioId,
      packageScenarioId: element.packageScenarioId,
      palletConfigurationUpdated: element.palletConfigurationUpdated,
    };
  }

  ngOnInit(): void {
    this.settingIcon = './assets/icons/Settings_Icon.png';
    this.scenarioIcon = './assets/icons/Scenario_Icon.png';
    this.reportIcon = './assets/icons/Report_Icon.png';
    this.sideBarCall = this.sharedService.sideBarData$.pipe(skip(1)).subscribe((data: any) => {
      this.changeCurrentRoute();
      this.setDynamicMenu();
      if (data == 'isGuidedTour') {
        this.openDialog();
        this.isGuidedTour = true;
      } else if (data == 'charts') {
        this.openChartSection();
        this.isGuidedTour = true;
      } else {
        this.isGuidedTour = false;
      }
    });
    this.checkInterpretationAccess();
  }

  checkInterpretationAccess(): void {
    this.hasInterpretationAccess = isFeatureEnabled(FeatureCodes.REPORTS_INTERPRETATION_SECTION);
  }

  handleInterpretationClick(event: Event, children: any, children2: any): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.hasInterpretationAccess) {
      this.navigate(children, children2, children2.link);
    }
  }

  async startTour(initTour?: any) {
    this.joyrideService.closeTour();
    const getPackageId: any = this.cookieService.get('gT_PackageId');
    this.activatedRouteProjectId = parseFloat(getPackageId);
    this.setDynamicMenu();
    if (initTour)
      this.router.navigate(
        [
          `projects/projects-setting/${customEncode(
            btoa(encodeURIComponent(this.activatedRouteProjectId))
          )}/interpretation`,
        ],
        { queryParams: { qPrm: 'MwfsudQnxc', isTour: 'zCsdAaPXQy' } }
      );
    await lastValueFrom(this.reportService.getInterpretationDetail(this.activatedRouteProjectId));
    localStorage.setItem('scenarioName', 'Interpretation');
    const options = {
      steps: this.advancedTourSteps,
      stepDefaultPosition: 'bottom',
      themeColor: '#9747FF',
      showPrevButton: true,
      logsEnabled: false,
      scrollIfStepAndTargetAreNotVisible: true,
      waitingTime: 100,
    };
    document.body.classList.add('guided-tour-active');
    this.joyrideService.startTour(options).subscribe(
      step => {
        this.stepNum = step?.number;
        if (step.number == 1 || step.number == 4 || step.number == 14 || step.number == 13) {
          delayedFunctionCall(this.scrollToTop, 0, this);
        } else {
          switch (step.number) {
            case 5:
            case 6:
              this.scrollToSpecific('critical-sect', 6);
              break;
            case 7:
            case 8:
              this.scrollToSpecific('sys-boundary', 8);
              break;
            case 9:
            case 10:
              this.scrollToSpecific('dqa-grid', 10);
              break;
            case 11:
              this.scrollToSpecific('interpretation-sect', 12);
              break;
            case 15:
            case 16:
            case 17:
              this.scrollToSpecific('sens-analysis', 16);
              break;
            default:
              break;
          }
        }
      },
      e => {},
      () => {
        document.body.classList.remove('guided-tour-active');
        const tourName = localStorage.getItem('tourName');
        this.sharedService.startTourFun(false);
        this.sharedService
          .updateGuideTourStatus(GuideTourEnum.AdvancedTour, false, this.stepNum)
          .subscribe();
        this.router.navigate([`/dashboard`]);
        // comment take me there pop up
        const redirectToPreference = JSON.parse(this.cookieService.get('redirectToPreference'));
        const licenseType = parseInt(sessionStorage.getItem('licenseType') || '0', 10);
        if (
          !this.mTr &&
          redirectToPreference &&
          tourName != 'manual' &&
          licenseType != LicenseType.Trial
        )
          this.sharedService.showPreferencesPopup();
        localStorage.removeItem('tourName');
      }
    );
  }

  scrollToSpecific(eleId: any, stepNum: any) {
    const ele = document.getElementById(eleId);
    if (ele) {
      const elementPosition = ele.getBoundingClientRect().top + window.scrollY;
      const scrollToPosition =
        stepNum == 8
          ? elementPosition - 300
          : stepNum == 10
          ? elementPosition - 500
          : stepNum == 12
          ? elementPosition - 800
          : stepNum == 13
          ? elementPosition - 700
          : elementPosition - 400;
      setTimeout(() => {
        window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
      }, 0);
    }
  }

  onComplete() {
    this.sharedService.updateGuideTourStatus(GuideTourEnum.BasicTour, true).subscribe();
    const userType: any = this.cookieService.get('u_type');

    const redirectToPreference = JSON.parse(this.cookieService.get('redirectToPreference'));
    document.body.classList.remove('guided-tour-active');
    const tourName = localStorage.getItem('tourName');

    // Check if advanced guided tour feature is enabled
    const isAdvancedTourEnabled = isFeatureEnabled(FeatureCodes.HELP_ADVANCED_GUIDED_TOUR);

    if (isAdvancedTourEnabled) {
      this.swalService
        .confirm("You're good to go!", 'Would you like a tour of the Advanced reporting section?')
        .then(confirmed => {
          if (confirmed) {
            this.startTour(true);
          } else {
            this.navigateToDashboard(redirectToPreference, userType, tourName);
          }
        });
    } else {
      this.navigateToDashboard(redirectToPreference, userType, tourName);
    }
  }

  private navigateToDashboard(redirectToPreference: any, userType: any, tourName: string | null) {
    this.router.navigate([`/dashboard`]);
    this.sharedService.startTourFun(false, 'Yes');
    const licenseType = parseInt(sessionStorage.getItem('licenseType') || '0', 10);
    if (
      redirectToPreference &&
      this.sharedService.decodeURIComponentParam(userType)?.toLowerCase() == adminRoleStr &&
      tourName != 'manual' &&
      licenseType != LicenseType.Trial
    ) {
      this.sharedService.showPreferencesPopup();
    }

    localStorage.removeItem('tourName');
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  onPrevReports(indx: any, stepType: any) {
    if (!indx && stepType == 'chart-at-glance') {
      this.sharedService.accessSideBarData('isGuidedTour');
      const valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${this.packageScenarioId}, "eId": ${this.eId}}`;
      const encryptedValue = encrypt(valueToEncrypt);
      this.router.navigate(
        [
          `projects/projects-setting/${customEncode(
            btoa(encodeURIComponent(this.activatedRouteProjectId))
          )}/end-of-life`,
        ],
        { queryParams: { param: encryptedValue } }
      );
    }
    if (indx == 1 && stepType?.toLowerCase() == 'interpretation') {
      this.router.navigate([
        `projects/projects-setting/${customEncode(
          btoa(encodeURIComponent(this.activatedRouteProjectId))
        )}/chart-at-glance`,
      ]);
    }
  }

  onPrev(indx: any, step?: any) {
    if (indx == 1 && step?.toLowerCase() !== 'materials') {
      setTimeout(() => {
        this.router.navigate([`/dashboard`]);
        window.scroll({ top: 1000, behavior: 'smooth' });
      }, 20);
    } else if (indx == 4 && step?.toLowerCase() == 'filling') {
      const valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${this.packageScenarioId}, "eId": ${this.eId}}`;
      const encryptedValue = encrypt(valueToEncrypt);
      const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
      this.router.navigate(
        [`projects/projects-setting/${customEncode(btoa(encodedValue))}/product-loss`],
        { queryParams: { param: encryptedValue } }
      );
    } else if (!indx && step?.toLowerCase() == 'configuration') {
      const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
      this.router.navigate([
        `projects/projects-setting/${customEncode(btoa(encodedValue))}/setting`,
      ]);
    }
  }

  onNext(index: any, step?: string) {
    if (index == 4 && step == 'Filling') {
      const valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${
        this.packageScenarioId
      }, "eId": ${this.eId}, "haveTour": ${true}}`;
      const encryptedValue = encrypt(valueToEncrypt);
      const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
      this.router.navigate(
        [`projects/projects-setting/${customEncode(btoa(encodedValue))}/end-of-life`],
        { queryParams: { param: encryptedValue } }
      );
    }
  }

  openDialog() {
    this.activeIdsMain = [];
    this.activeIdsSub = [];
    this.activeIdsMain.push('panel-main-' + 1);
    this.activeIdsSub.push('panel-sub-' + 0);
  }

  openChartSection() {
    this.activeIdsMain = [];
    this.activeIdsSub = [];
    this.activeIdsMain.push('panel-main-' + 2);
    this.activeIdsSub.push('panel-sub-' + 0);
  }

  ngOnDestroy() {
    this.menuItems?.forEach((item: any) => {
      item.isActive = false;
    });
    this.sharedService.scenarioNameFunc('');
    this.sideBarCall?.unsubscribe();
    this.guidedTourData?.unsubscribe();
    localStorage.removeItem('scenarioName');
    localStorage.removeItem('pCode');
  }

  ngAfterViewInit() {
    if (this.flagName) {
      this.closeOthers = false;
    }
    this.guidedTourData = this.sharedService.startTourObs$.subscribe((data: any) => {
      if (!data[0]) this.updateHeight();
      if (data[0] && data[1] == 'init') {
        document.getElementById('scrollableDiv')?.classList.add('gt-class');
      }
      this.iSTourOn = data;
    });
    // Initialize the height of contentDiv
    // Create a MutationObserver to detect changes in the height
    const observer = new MutationObserver(() => {
      if (!this.iSTourOn) this.updateHeight();
    });
    if (!this.iSTourOn)
      observer.observe(this.sideMenu.nativeElement, { attributes: true, subtree: true });
  }

  updateHeight() {
    var screenZoomLevel = window.devicePixelRatio || 1; // Get the screen zoom level
    var finalHeight;

    const adjustedVh = this.calculateAdjustedVh(screenZoomLevel);
    const adjustedHeightInPx = this.vhToPixels(adjustedVh);
    finalHeight = adjustedHeightInPx;

    // Check if the screen zoom level is less than 1 (i.e., less than 100%)
    if (screenZoomLevel < 1) {
      // Set the new height to the div
      this.sideMenu.nativeElement.style.minHeight = finalHeight + 'px';
    } else {
      // If zoom level is 1 (100%), set height to 61vh
      this.sideMenu.nativeElement.style.minHeight = '61vh';
    }
    const height = this.sideMenu.nativeElement.offsetHeight;
    var contentDiv = document.getElementById('scrollableDiv') as HTMLElement;
    if (contentDiv) contentDiv.style.height = height + 20 + 'px';
  }

  calculateAdjustedVh(zoomLevel: any) {
    // Define the zoom levels and their corresponding assumed heights
    const zoomLevels = [1, 0.8, 0.75, 0.5, 0.33, 0.25]; // Corresponding to 100%, 80%, 75%, 50%, 33%, 25%
    const assumedHeights = [61, 63, 65, 70, 80, 84]; // Corresponding assumed heights in vh

    // Find the closest zoom level to the provided zoom level
    let closestZoomLevel = zoomLevels.reduce((prev, curr) => {
      return Math.abs(curr - zoomLevel) < Math.abs(prev - zoomLevel) ? curr : prev;
    });

    // Find the index of the closest zoom level
    let index = zoomLevels.indexOf(closestZoomLevel);

    // Return the assumed height corresponding to the closest zoom level
    return assumedHeights[index];
  }

  vhToPixels(vh: any) {
    // Calculate the viewport height in pixels
    const viewportHeightPx = window.innerHeight;

    // Convert vh value to pixels
    return (vh / 100) * viewportHeightPx;
  }
}
